import { combineReducers } from 'redux';
import {
    RecommendationsFetchSuccessActionType,
    RecommendationsFetchRequestActionType,
    RecommendationsFetchFailureActionType,
} from './recommendedServicesAction';
import { ActionType } from 'store/ActionType';
import { Service } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

const recommendedServices = (
    state: Nullable<Service[]> = null,
    action: ActionType,
) => {
    switch (action.type) {
        case RecommendationsFetchSuccessActionType:
            {
                return action.payload;
            }
        default: {
            return state;
        }
    }
};

const isLoading = (state = false, action: ActionType) => {
    switch (action.type) {
        case RecommendationsFetchRequestActionType: {
            return true;
        }
        case RecommendationsFetchFailureActionType:
        case RecommendationsFetchSuccessActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    recommendedServices,
    isLoading,
});
